import styled from 'styled-components';
import { Row, media } from '@simplywallst/ui-core';

export const MainContainer = styled('section')`
  width: 100%;
  background-color: ${({ theme }) => theme.color.white};
`;

export const HeaderContainer = styled(Row)`
  background-color: ${({ theme }) => theme.color.brand04RGBA(0.2)};
  width: 100%;
`;

export const NavContainer = styled('div')`
  padding: ${({ theme }) => theme.x2spacePx}px;
`;

export const Header = styled('header')`
  text-align: center;
  color: ${({ theme }) => theme.color.spaceGray};
  h1 {
    margin: 18px 0 0;
    ${({ theme }) => theme.typography.base}
    font-weight: 700;
  }
  h2 {
    padding-top: 24px;
    ${({ theme }) => theme.typography.mega}
    letter-spacing: -0.02em;
    font-weight: 700;
    line-height: 36px;
    margin: auto;
    ${media.lgUp`
      font-size: 3.2rem;
    `}
  }
`;
